<div class=" title-container align-items-center mb-5">
    <img class="mobile-title-logo" src="./assets/icons/arrow.svg">
    <span class="label-title ml-2 mr-3">Criar Grupo</span>
</div>
<div class="row timeline-row">
    <div class="center">
        <div (click)="redirect('portal/grupos/create', 1)" [ngClass]="step > 0 ? 'active': 'inactive'" class="span-container">
            <img class="w-50" src="./assets/icons/grupos/nome_grupo.svg">
        </div>
        <span class="subtitle mt-2 active-mobile">Nome do grupo</span>
    </div>

    <div [ngClass]="step > 1 ? 'active': 'inactive'" class="separador mr-4 ml-4"></div>
    <div [ngClass]="step > 1 ? 'active-mobile': 'inactive-mobile'" class="separador-mobile ml-2 mr-2">></div>

    <div class="center">
        <div (click)="redirect('portal/grupos/beneficios', 2)" [ngClass]="step > 1 ? 'active': 'inactive'" class="span-container">
            <img class="w-50" src="./assets/icons/grupos/beneficios.svg">
        </div>
        <span [ngClass]="step > 1 ? 'active-mobile': 'inactive-mobile'" class="subtitle mt-2">Produtos</span>
    </div>

    <div [ngClass]="step > 2 ? 'active': 'inactive'" class="separador mr-4 ml-4"></div>
    <div [ngClass]="step > 2 ? 'active-mobile': 'inactive-mobile'" class="separador-mobile ml-2 mr-2">></div>

    <div class="center">
        <div (click)="redirect('portal/grupos/regras', 3)" [ngClass]="step > 2 ? 'active': 'inactive'" class="span-container">
            <img class="w-50" src="./assets/icons/grupos/regras.svg">
        </div>
        <span [ngClass]="step > 2 ? 'active-mobile': 'inactive-mobile'" class="subtitle mt-2">Regras</span>
    </div>

    <!-- <div [ngClass]="step > 3 ? 'active': 'inactive'" class="separador mr-4 ml-4"></div>
    <div [ngClass]="step > 3 ? 'active-mobile': 'inactive-mobile'" class="separador-mobile ml-2 mr-2">></div>

    <div class="center">
        <div [ngClass]="step > 3 ? 'active': 'inactive'" class="span-container">
            <img class="w-40" src="./assets/icons/grupos/resumo.svg">
        </div>
        <span [ngClass]="step > 3 ? 'active-mobile': 'inactive-mobile'" class="subtitle mt-2">Resumo</span>
    </div> -->
</div>
